export const NOT_FOUND_CODE = 404;
export const MAX_IMAGE_SIZE = 5_242_880;

export const eventTypes = {
  dragEnter: 'dragenter',
  dragOver: 'dragover',
  dragLeave: 'dragleave',
};
